const Avatar = ({name, color}) => {
    return (<div className="avatar" style={{backgroundColor: color}}>{ name.charAt(0) }</div>)
}

export default Avatar;